import React from "react";
import { ListChecks } from "lucide-react";

/**
 * Small chip strip shown under the header while in select mode.
 * Currently offers the "Select whole chapter" preset.
 */
export default function SelectionPresets({ selectMode, verseCount, allSelected, selectionCount = 0, onSelectWholeChapter, onClearAll }) {
    if (!selectMode) return null;
    return (
        <div
            data-testid="selection-presets"
            className="mx-5 md:mx-8 mt-3 flex flex-wrap items-center gap-2"
        >
            <span className="font-ui text-[11px] uppercase tracking-[0.18em] text-ink-40 mr-1">
                Presets
            </span>
            <button
                data-testid="preset-whole-chapter"
                onClick={onSelectWholeChapter}
                disabled={allSelected || !verseCount}
                className={
                    "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full font-ui text-[12px] transition " +
                    (allSelected
                        ? "bg-moss/15 text-moss-deep cursor-default"
                        : "bg-white border border-ink-10 text-ink hover:border-moss/40 hover:bg-moss/5")
                }
                aria-label={`Select all ${verseCount} verses in this chapter`}
            >
                <ListChecks size={13} />
                {allSelected ? "Whole chapter selected" : `Select whole chapter${verseCount ? ` (${verseCount})` : ""}`}
            </button>
            {selectionCount > 0 && (
                <button
                    data-testid="preset-clear"
                    onClick={onClearAll}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full font-ui text-[12px] text-ink-70 hover:text-ink hover:bg-ink-10 transition"
                >
                    Clear
                </button>
            )}
        </div>
    );
}
